import {
  SETTINGS_TAB_VALUE_BY_KEY,
  getLegacySettingsTabs,
  hasSettingsTabPermission,
  isOrganizationSettingsTabEnabled,
} from "../config/settingsModuleCatalog";
import { getLayoutSection, getPageTitleKey } from "./moduleLayoutUtils";

export { hasSettingsTabPermission };

function resolveTabLabel(widget, t) {
  if (widget.translateLabel === false) {
    return widget.labelKey;
  }
  return t(widget.labelKey || widget.tabKey);
}

export function buildSettingsTabsFromLayout(
  layout,
  { t, isSuperAdmin, school, features, enabledSettingsTabs },
) {
  const tabSection = getLayoutSection(layout, "settingsTabBar");
  if (!tabSection?.widgets) return null;

  const tabs = tabSection.widgets
    .map((widget) => ({
      tabKey: widget.tabKey,
      labelKey: widget.labelKey || widget.tabKey,
      value: SETTINGS_TAB_VALUE_BY_KEY[widget.tabKey],
      translateLabel: widget.translateLabel !== false,
      permission: widget.permission || null,
      superAdminOnly: Boolean(widget.superAdminOnly),
      hideForSchool: Boolean(widget.hideForSchool),
      order: typeof widget.order === "number" ? widget.order : 0,
    }))
    .filter((tab) => tab.value !== undefined);

  const filtered = tabs
    .filter((tab) => !tab.superAdminOnly || isSuperAdmin)
    .filter((tab) => !school || !tab.hideForSchool)
    .filter((tab) => hasSettingsTabPermission(tab.permission, features))
    .filter((tab) =>
      isOrganizationSettingsTabEnabled(tab.tabKey, enabledSettingsTabs),
    )
    .sort((a, b) => a.order - b.order);

  return filtered.map((tab) => ({
    tabKey: tab.tabKey,
    labelKey: tab.labelKey,
    value: tab.value,
    label: resolveTabLabel(tab, t),
  }));
}

export { getPageTitleKey, getLegacySettingsTabs };
